import { useEffect, useState } from "react";

function App() {

  const [userChoice, setUserChoice] = useState('rock');
  const [computerChoice, setComputerChoice] = useState('rock');
  const [userPoints, setUserPoints] = useState(0);
  const [computerPoints, setComputerPoints] = useState(0);
  const [turnResult, setTurnResult] = useState(null);
  const [finalResult, setFinalResult] = useState("Let's see who wins");
  const [gameOver, setGameOver] = useState(false);
  const [userGotPoint, setUserGotPoint]= useState(false);

  const choices = ['rock', 'paper', 'scissors'];

  const handleClick = (choice) => {
    setUserChoice(choice);
    const randomChoice = choices[Math.floor(Math.random() * choices.length)];
    setComputerChoice(randomChoice);
  }

  const reset = () => {
    window.location.reload();
  }

  const userStyle={
    color: "green"
  };
  const computerStyle={
    color: "red"
  };

  useEffect(() => {
    const comboMoves = userChoice + computerChoice;
    if (userPoints <= 4 && computerPoints <= 4) {
      //when user gets a point
      if (comboMoves === 'rockscissors' || comboMoves === 'paperrock' || comboMoves === 'scissorspaper') {
        const updatedUserPoints = userPoints + 1;
        setUserPoints(updatedUserPoints);
        setTurnResult('You got the point');
        setUserGotPoint(true);
        if (updatedUserPoints === 5) {
          setGameOver(true);
          setFinalResult('You won!');
        }
      }

      //when computer gets a point
      if (comboMoves === 'scissorsrock' || comboMoves === 'rockpaper' || comboMoves === 'paperscissors') {
        const updatedComputerPoints = computerPoints + 1;
        setComputerPoints(updatedComputerPoints);
        setTurnResult('Computer got the point');
        setUserGotPoint(false);
        if (updatedComputerPoints === 5) {
          setGameOver(true);
          setFinalResult('Computer wins!');
        }
      }

      //when no one gets a point
      if (comboMoves === 'rockrock' || comboMoves === 'paperpaper' || comboMoves === 'scissorsscissors') {
        setTurnResult('No one got the point!');
        setUserGotPoint(false);
      }
    }
  }, [userChoice, computerChoice]);



  return (
    <div>
      <h1 className="heading">Rock Paper Scissors</h1>

      <div className="container">
        <div className="user">
          <h2>Your Points: {userPoints}</h2>
          <div className="choice-user">
            <img className="user-hand" src={require(`./images/${userChoice}.png`)} alt="" ></img>
          </div>
          {
            !gameOver &&
            <div className="button-div">
              {
                choices.map((choice, index) => {
                  return (
                    <button className="button" key={index} onClick={() => handleClick(choice)}>{choice}</button>
                  )
                })
              }
            </div>
          }
        </div>

        <div className="computer">
          <h2>Computer Points: {computerPoints}</h2>
          <div className="choice-computer">
            <img className="computer-hand" src={require(`./images/${computerChoice}.png`)} alt="" />
          </div>
        </div>
      </div>

      <div className="result">
        <h3 style={ userGotPoint ? userStyle : computerStyle }>{turnResult}</h3>
        <h1>{finalResult}</h1>
      </div>

      <div className="button-div">
        {
          gameOver &&
          <button className="button restart" onClick={() => reset()}>Restart Game ? </button>
        }
      </div>

    </div>
  );
}

export default App;
